// components
import {
  styled,
  Box,
  Typography,
  IconButton,
  BoxProps,
  TypographyProps,
  IconButtonProps
} from '@mui/material';
import { StyledBoxFlexCenterSmallGap } from 'components/shared/Box/Box.styles';

export const StyledValueAndIconButtonContainer = styled(
  StyledBoxFlexCenterSmallGap
)(() => ({
  display: 'contents',
  '&:hover .show-on-hover': {
    opacity: 1
  }
}));

export const StyledTooltipTitleBox = styled(Box)<BoxProps>(({ theme }) => ({
  padding: theme.spacing(1, 1.5)
}));

export const StyledCenteredTypography = styled(Typography)<TypographyProps>(
  () => ({
    display: 'flex',
    alignItems: 'center'
  })
);

export const StyledVisibleIconButtonOnHover = styled(
  IconButton
)<IconButtonProps>(() => ({
  opacity: 0,
  transition: 'opacity 0.3s'
}));
